/**
 * This file contains the default (english) values for all available translations.
 * Default translations can be downloaded from the Nav Manager UI:
 * https://tools.hubteam.com/navigation-manager-ui/translation
 *
 * DO NOT ADD TRANSLATIONS MANUALLY.
 * Download the latest translations from the Nav Manager UI and overwrite
 * the values in this file.
 *
 * Add a comment in your PR to confirm that you downloaded the latest
 * translations from the Nav Manager UI.
 */
export const defaultTranslations = {
  'nav.account.accountBilling': 'Account & Billing',
  'nav.account.allAccounts': 'All accounts',
  'nav.account.credits.count': '{{count}} of {{total}} credits available',
  'nav.account.credits.noCredits': 'No credits available',
  'nav.account.credits.title': 'HubSpot Credits',
  'nav.account.hubspotAcademy': 'HubSpot Academy',
  'nav.account.hubspotSoftware': 'HubSpot Software',
  'nav.account.portalPicker.accountLabel': 'Account: {{accountName}}',
  'nav.account.pricingFeatures': 'Pricing & Features',
  'nav.account.privacy': 'Privacy policy',
  'nav.account.productUpdates': 'Product Updates',
  'nav.account.profileLink': 'Profile & Preferences',
  'nav.account.projects': 'Projects',
  'nav.account.signOut': 'Sign out',
  'nav.account.trainingServices': 'Training & Services',
  'nav.accountMenu.optInLink': 'Switch to the latest navigation',
  'nav.accountMenu.optOutLink': 'Switch to the original navigation',
  'nav.accountMenu.optOutLink2': 'Switch to the previous navigation',
  'nav.accountMenu.shareNavFeedback': 'Share navigation feedback',
  'nav.alerts.accountPastDue.description': 'Please submit your payment or contact us to settle your invoice.',
  'nav.alerts.accountPastDue.linkText': 'Contact us',
  'nav.alerts.accountPastDue.title': 'Your HubSpot account payment is overdue.',
  'nav.alerts.apollo.description': 'Send your admin an email to let them know.',
  'nav.alerts.apollo.linkText': 'Send email',
  'nav.alerts.apollo.title': 'Your HubSpot account payment is overdue.',
  'nav.alerts.apolloAdmin.description': 'Please pay all outstanding invoices.',
  'nav.alerts.apolloAdmin.linkText': 'View invoices',
  'nav.alerts.apolloAdmin.title': 'Your HubSpot account payment is overdue.',
  'nav.alerts.close': 'Close',
  'nav.alerts.closeBannerIcon': 'close banner icon',
  'nav.alerts.developer.description': 'Discover the different HubSpot account types and their purposes.',
  'nav.alerts.developer.linkText': 'Click here to explore the developer documentation',
  'nav.alerts.developer.title': 'This is an app developer account.',
  'nav.alerts.example1': 'Nav Alerts!',
  'nav.alerts.example2': 'More Nav Alerts!',
  'nav.alerts.ieDeprecated.description': 'Update your browser to avoid performance issues in HubSpot.',
  'nav.alerts.ieDeprecated.dismiss': 'Dismiss',
  'nav.alerts.ieDeprecated.linkText': 'Learn How.',
  'nav.alerts.ieDeprecated.title': 'HubSpot will no longer support Internet Explorer 11.',
  'nav.alerts.impersonation.active': 'You are temporarily logged in as {{ firstName }} {{ lastName }} and actions taken in this account will be saved.',
  'nav.alerts.impersonation.active-userName': 'You are temporarily logged in as {{ userName }} and actions taken in this account will be saved.',
  'nav.alerts.impersonation.hint': 'Sign out to regain access to your account.',
  'nav.alerts.inaccurateNav.description': 'Please check our system status for outages.',
  'nav.alerts.inaccurateNav.linkText': 'HubSpot Status',
  'nav.alerts.inaccurateNav.title': 'Sorry. The server was unable to accurately determine what tools you have access to.',
  'nav.alerts.jitaDefault.description': 'Request elevated access',
  'nav.alerts.jitaDefault.title': 'Just-in-time access.',
  'nav.alerts.jitaElevated.description': 'Use good judgment.',
  'nav.alerts.jitaElevated.title': 'Elevated just-in-time access.',
  'nav.alerts.sandbox.developmentSandbox': "You're in {{ sandboxName }}, which is a development sandbox account.",
  'nav.alerts.sandbox.linkText': 'Go back to my production account.',
  'nav.alerts.sandbox.sandboxAccount': "You're in {{ sandboxName }}, which is a standard sandbox account.",
  'nav.alerts.sandbox.somethingWentWrong': 'Something went wrong finding the url for your production account. Please reload the page to try again.',
  'nav.alerts.sandbox.title': 'This is a Sandbox account',
  'nav.alerts.suspended.description': 'All you need to do is update your billing information.',
  'nav.alerts.suspended.linkText': 'View invoices',
  'nav.alerts.suspended.title': 'Your account is locked. But you have the key.',
  'nav.badges.beta': 'Beta',
  'nav.badges.comingSoon': 'Coming Soon',
  'nav.badges.new': 'New',
  'nav.badges.trial': 'Trial',
  'nav.badges.trialTooltipText': 'Included in your active trial',
  'nav.bookmarks.button.add.ariaLabel': 'Add {{ menuItem }} menu item to Bookmarks Menu',
  'nav.bookmarks.button.remove.ariaLabel': 'Remove {{ menuItem }} menu item from Bookmarks Menu',
  'nav.bookmarks2.add': 'Add to bookmarks',
  'nav.bookmarks2.emptyBody': 'Select the bookmark icon next to any item in the navigation to add it here.',
  'nav.bookmarks2.emptyTitle': 'Add your first bookmark for quick access.',
  'nav.bookmarks2.limitReached': 'You can have 5 bookmarks. To add this, remove another one first.',
  'nav.bookmarks2.primaryNav': 'Bookmarks',
  'nav.bookmarks2.remove': 'Remove from bookmarks',
  'nav.bookmarks3.limitReached': 'You can have 10 bookmarks. To add this, remove another one first.',
  'nav.calling.alerts.callingAccess.callingDisabled.linkText': 'calling',
  'nav.calling.alerts.callingAccess.callingDisabled.message': 'Please talk with your account admin about enabling calling. Learn more about ',
  'nav.calling.alerts.callingAccess.callingDisabled.title': "Calling isn't enabled in HubSpot.",
  'nav.calling.alerts.callingAccess.noAccess.message': 'Please talk to your account admin.',
  'nav.calling.alerts.callingAccess.noAccess.title': "You don't have access to calling.",
  'nav.calling.alerts.callingAccess.noPortalFromNumbers.message': 'Please talk to your account admin.',
  'nav.calling.alerts.callingAccess.noPortalFromNumbers.title': 'You don’t have a HubSpot phone number.',
  'nav.calling.alerts.callTab.button': 'Open call tab',
  'nav.calling.alerts.callTab.content': 'In order to receive inbound calls, you must enable inbound calling by opening the call tab. Learn more about ',
  'nav.calling.alerts.callTab.header': 'Your inbound call tab is closed or disconnected.',
  'nav.calling.alerts.callTab.linkText': 'calling availability',
  'nav.calling.alerts.connectionError.message': 'Please refresh your page.',
  'nav.calling.alerts.connectionError.offline.button': 'Reconnect',
  'nav.calling.alerts.connectionError.offline.message': "This occurs when your computer has been asleep for a while or there's an internet connectivity issue. Please try reconnecting when you're ready to receive calls again.",
  'nav.calling.alerts.connectionError.offline.title': 'Calling is offline',
  'nav.calling.alerts.connectionError.title': 'There was an error',
  'nav.calling.alerts.criticalError.button': 'Reopen calling',
  'nav.calling.alerts.criticalError.message': 'An error has occurred preventing inbound calls. To restore inbound calling, please close the window and reopen it.',
  'nav.calling.alerts.criticalError.title': 'Unable to receive calls.',
  'nav.calling.alerts.outboundCallInProgress.message': 'You cannot receive inbound calls while an outbound call is ongoing. Inbound calls will resume after the outbound call is disconnected.',
  'nav.calling.alerts.outboundCallInProgress.title': 'Active outbound call in progress.',
  'nav.calling.callActions.available': 'Available',
  'nav.calling.callActions.callDuration': 'Call Duration',
  'nav.calling.callActions.cancel': 'Cancel',
  'nav.calling.callActions.cancelTransfer': 'Cancel Transfer',
  'nav.calling.callActions.endCall': 'End Call',
  'nav.calling.callActions.handoff': 'Hand off',
  'nav.calling.callActions.noAnswer': 'No Answer',
  'nav.calling.callActions.recording': 'Recording...',
  'nav.calling.callActions.saveCall': 'Save Call',
  'nav.calling.callActions.startCall': 'Start call',
  'nav.calling.callActions.transfer': 'Transfer',
  'nav.calling.callActions.unavailable': 'Away',
  'nav.calling.callIcon.title': 'Calling',
  'nav.calling.callOptions.audio': 'Audio',
  'nav.calling.callOptions.callReview.callDetails': 'Take notes',
  'nav.calling.callOptions.callReview.clickToOpenCallDetails': 'Click to open new Call Details tab',
  'nav.calling.callOptions.hold': 'Hold',
  'nav.calling.callOptions.keypad': 'Keypad',
  'nav.calling.callOptions.microphone': 'Microphone',
  'nav.calling.callOptions.microphoneSelectionDisabled': "Your browser doesn't support changing microphone devices",
  'nav.calling.callOptions.mute': 'Mute',
  'nav.calling.callOptions.openKeypad': 'Open Keypad',
  'nav.calling.callOptions.record': 'Record',
  'nav.calling.callOptions.reviewCall': 'Review call',
  'nav.calling.callOptions.speakers': 'Speakers',
  'nav.calling.callOptions.startRecording': 'Start Recording',
  'nav.calling.callOptions.stopRecording': 'Stop Recording',
  'nav.calling.callOptions.toggleHold': 'Toggle Hold',
  'nav.calling.callOptions.unknownDevice': 'Unknown Device',
  'nav.calling.callOptions.unmute': 'Unmute',
  'nav.calling.callProfile.clickToOpenContactPage': 'Click to open contact page',
  'nav.calling.callProfile.noActive': 'No Active Call',
  'nav.calling.callProfile.onHold': 'On Hold',
  'nav.calling.callProfile.title.inactive': 'CALL REMOTE',
  'nav.calling.callProfile.title.inbound': 'INBOUND CALL',
  'nav.calling.callProfile.title.inboundNamedNumber': 'INBOUND CALL to',
  'nav.calling.callProfile.title.outbound': 'OUTBOUND CALL',
  'nav.calling.callProfile.title.outboundNamedNumber': 'OUTBOUND CALL from',
  'nav.calling.callProfile.title.ringing': 'Ringing...',
  'nav.calling.callProfile.title.successfulTransfer': 'Your transfer was successful.',
  'nav.calling.callProfile.title.transfer': 'TRANSFER CALL',
  'nav.calling.callProfile.unknown': 'Unknown',
  'nav.calling.callProfile.unknownCaller': 'Unknown caller',
  'nav.calling.callProfile.unknownContact': 'Unknown contact',
  'nav.calling.dialer.activeState.back': 'Back',
  'nav.calling.dialer.alert.noCallTabExists': "You're unavailable for inbound calls.",
  'nav.calling.dialer.alert.noCallTabExistsCallingAvailability': 'calling availability.',
  'nav.calling.dialer.alert.noCallTabExistsContent': 'Learn about',
  'nav.calling.dialer.fromNumberSelect.callFrom.label': 'Call From',
  'nav.calling.dialer.fromNumberSelect.callProviders.hubSpot': 'HubSpot Calling',
  'nav.calling.dialer.fromNumberSelect.callProviders.twilio': 'Twilio Connect',
  'nav.calling.dialer.fromNumberSelect.countryCode.invalidCountryOption': 'Invalid country',
  'nav.calling.dialer.fromNumberSelect.selectANumber': 'Select a number',
  'nav.calling.dialer.fromNumberSelect.source.externalNumber': 'External number',
  'nav.calling.dialer.fromNumberSelect.source.hubSpotNumber': 'HubSpot number',
  'nav.calling.dialer.invalidNumber': 'Please enter a valid phone number.',
  'nav.calling.dialer.ringPreferencesAlert.content': 'To change your ring preference, go to your',
  'nav.calling.dialer.ringPreferencesAlert.header': 'Your inbound calls are not set to ring in the browser.',
  'nav.calling.dialer.ringPreferencesAlert.userCallSettings': 'user call settings.',
  'nav.calling.dialer.unknownContact': 'Unknown contact',
  'nav.calling.onboarding.message': 'You can answer incoming calls and look up your caller’s CRM records right here in your HubSpot workspace.',
  'nav.calling.onboarding.primaryCta': 'Learn more',
  'nav.calling.onboarding.skip': "Don't show me this again",
  'nav.calling.onboarding.title': 'Inbound Calling',
  'nav.calling.transferNotification.accept': 'Accept',
  'nav.calling.transferNotification.decline': 'Decline',
  'nav.calling.transferNotification.from': 'From',
  'nav.calling.transferNotification.title': 'Incoming Transfer',
  'nav.calling.transferNotification.transferring': 'Transferring',
  'nav.calling.twilioClientErrors.31005.message': 'A connection error occurred during the call.',
  'nav.calling.twilioClientErrors.31005.title': 'Connection error.',
  'nav.calling.twilioClientErrors.31208.message': 'Please allow access so it can be used for calling. Then, refresh and try calling again. ',
  'nav.calling.twilioClientErrors.31208.title': 'Microphone error.',
  'nav.calling.twilioClientErrors.32014.message': 'Ensure your audio system is working properly and try again. ',
  'nav.calling.twilioClientErrors.32014.title': 'No audio was detected during this call.',
  'nav.calling.twilioClientErrors.53405.message': 'Please select a microphone and/or speaker output in the audio device menu',
  'nav.calling.twilioClientErrors.53405.title': 'Audio connection ceased ',
  'nav.calling.twilioClientErrors.learnMore': 'Learn More.',
  'nav.calling.twilioClientErrors.technicalRequirements': 'technical requirements for inbound calling.',
  'nav.calling.twilioClientErrors.unknown.message': 'Please check you meet the technical requirements for inbound calling. ',
  'nav.calling.twilioClientErrors.unknown.title': 'An error occurred.',
  'nav.defaultLandingPage.alertErrorMessage': 'Please try again later.',
  'nav.defaultLandingPage.alertSuccessMessages.automation': 'Your default page for Automation has been updated.',
  'nav.defaultLandingPage.alertSuccessMessages.crm': 'Your default page for CRM has been updated.',
  'nav.defaultLandingPage.alertSuccessMessages.library': 'Your default page for Library has been updated.',
  'nav.defaultLandingPage.alertSuccessMessages.marketing': 'Your default page for Marketing has been updated.',
  'nav.defaultLandingPage.alertSuccessMessages.marketplace': 'Your default page for Marketplace has been updated.',
  'nav.defaultLandingPage.alertSuccessMessages.partner-branch': 'Your default page for Partner has been updated.',
  'nav.defaultLandingPage.alertSuccessMessages.reports': 'Your default page for Reporting has been updated.',
  'nav.defaultLandingPage.alertSuccessMessages.website': 'Your default page for Website has been updated.',
  'nav.defaultLandingPage.alertTitles.errorTitle': "There's a problem setting the default page.",
  'nav.defaultLandingPage.alertTitles.successTitle': 'Success.',
  'nav.defaultLandingPage.items.cannotSetAsDefaultPage': "This can't be set as a default page yet.",
  'nav.defaultLandingPage.items.default': 'Default',
  'nav.defaultLandingPage.items.setAsDefaultPage': 'Set as Default Page',
  'nav.favorites.add': 'Add to favorites',
  'nav.favorites.icon.ariaLabel.default': 'Favorites icon',
  'nav.favorites.limitReached': 'You can only have 5 favorites. To add this, remove another one first.',
  'nav.favorites.primary': 'Favorites',
  'nav.favorites.remove': 'Remove from favorites',
  'nav.feedbackModal.close': 'Close',
  'nav.feedbackModal.completion.body': 'We appreciate your feedback',
  'nav.feedbackModal.completion.body2': 'We appreciate your feedback.',
  'nav.feedbackModal.completion.header': 'Thanks so much',
  'nav.feedbackModal.consensus': "I'm open to sharing my feedback about the new global navigation on a call with the HubSpot product team.",
  'nav.feedbackModal.generalConsensus': "I'm open to sharing my feedback about the global navigation on a call with the HubSpot product team.",
  'nav.feedbackModal.generalSurveyQuestion.happy': 'Tell us more about what you like or why you chose that rating.',
  'nav.feedbackModal.generalSurveyQuestion.neutral': 'Tell us more about why you chose that rating.',
  'nav.feedbackModal.generalSurveyQuestion.sad': 'Tell us more about what you dislike or why you chose that rating.',
  'nav.feedbackModal.generalSurveyQuestion.satisfaction': 'How would you rate the efficiency of the global navigation?',
  'nav.feedbackModal.rating.happy': 'Satisfied',
  'nav.feedbackModal.rating.neutral': 'Neutral',
  'nav.feedbackModal.rating.unhappy': 'Unsatisfied',
  'nav.feedbackModal.remove': 'remove',
  'nav.feedbackModal.submitButton': 'Submit',
  'nav.feedbackModal.surveyQuestion.happy': 'Please tell us more about what you liked or why you chose that rating.',
  'nav.feedbackModal.surveyQuestion.neutral': 'Please tell us more about why you chose that rating.',
  'nav.feedbackModal.surveyQuestion.sad': 'Please tell us more about what you disliked or why you chose that rating.',
  'nav.feedbackModal.surveyQuestion.satisfaction': 'How happy were you with the new global navigation experience?',
  'nav.feedbackModal.textarea': 'Optional',
  'nav.gettingStarted.finishSetup': 'Finish your account setup',
  'nav.gettingStarted.growthPlanHeader': 'Go to Growth Plan',
  'nav.gettingStarted.header': 'Set up your HubSpot account',
  'nav.gettingStarted.progress': 'Progress...',
  'nav.globalToolbar.spotlight': 'Explore Spotlight: 100+ updates',
  'nav.globalToolbar.spotlight2': 'Spotlight',
  'nav.globalToolbar.spotlight3': 'Explore Spotlight: 200+ updates',
  'nav.globalToolbar.superchargeAi': 'Supercharge your work with AI',
  'nav.globalToolbar.yearInReview': 'Year in review',
  'nav.help.button': 'Help',
  'nav.help.tooltip.first': 'Hi there, have any questions?',
  'nav.help.tooltip.full': 'Hi there, have any questions? We’re here to help.',
  'nav.help.tooltip.second': 'We’re here to help.',
  'nav.icons.chatspot': 'ChatSpot',
  'nav.icons.copilot': 'Copilot',
  'nav.icons.copilotAriaLabel': 'Open Copilot',
  'nav.icons.createNewObjectTooltip': 'Create new',
  'nav.icons.createObjectTooltip': 'Create',
  'nav.icons.externalLink': 'Link opens in a new window',
  'nav.icons.home': 'Home',
  'nav.icons.marketplace': 'Marketplace',
  'nav.icons.notifications': 'Notifications',
  'nav.icons.notifications_unseen': 'Notifications: {{ unseenCount }} unseen',
  'nav.icons.search': 'Search',
  'nav.icons.settings': 'Settings',
  'nav.inviteLink.text': 'Invite your team',
  'nav.inviteModal.text': 'Create a user',
  'nav.market.header': 'Marketplace',
  'nav.market.manageTitle': 'Manage',
  'nav.marketplaces.app.body': 'Find apps to integrate with HubSpot',
  'nav.marketplaces.app.title': 'App Marketplace',
  'nav.marketplaces.asset.body': 'Find website themes',
  'nav.marketplaces.asset.title': 'Asset Marketplace',
  'nav.marketplaces.connectedApps': 'Connected apps',
  'nav.marketplaces.manage': 'Manage',
  'nav.marketplaces.marketplaceDownloads': 'Marketplace downloads',
  'nav.marketplaces.purchasedAssets': 'Purchased assets',
  'nav.marketplaces.solutions.body': 'Find your perfect service provider match',
  'nav.marketplaces.solutions.title': 'Solutions Directory',
  'nav.marketplaces.template.body': 'Find website themes and modules',
  'nav.marketplaces.template.title': 'Template Marketplace',
  'nav.menu.showLess': 'Show less',
  'nav.menu.showMore': 'Show more',
  'nav.newButton.new': 'New',
  'nav.newButton.recent': 'Recent items',
  'nav.newButton.searchPlaceholder': 'Search here',
  'nav.objCreate.company': 'Company',
  'nav.objCreate.contact': 'Contact',
  'nav.objCreate.deal': 'Deal',
  'nav.objCreate.onboarding.company.body': 'Now, you can create companies and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.company.header': 'Create companies faster',
  'nav.objCreate.onboarding.contact.body': 'Now, you can create contacts and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.contact.header': 'Create contacts faster',
  'nav.objCreate.onboarding.deal.body': 'Now, you can create deals and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.deal.header': 'Create deals faster',
  'nav.objCreate.onboarding.new.company.body': 'Now, you can create new companies and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.new.contact.body': 'Now, you can create new contacts and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.new.deal.body': 'Now, you can create new deals and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.new.task.body': 'Now, you can create new tasks and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.new.ticket.body': 'Now, you can create new tickets and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.task.body': 'Now, you can create tasks and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.task.header': 'Create tasks faster',
  'nav.objCreate.onboarding.ticket.body': 'Now, you can create tickets and more right from the toolbar. No need to leave what you’re doing.',
  'nav.objCreate.onboarding.ticket.header': 'Create tickets faster',
  'nav.objCreate.ticket': 'Ticket',
  'nav.objectBuilderSidebar.company.iframeInitErrorMessage': 'There was a problem creating this Company. Please refresh the page and try again.',
  'nav.objectBuilderSidebar.company.successLinkText': 'View Company',
  'nav.objectBuilderSidebar.company.successMessage': 'A new Company has been created',
  'nav.objectBuilderSidebar.contact.iframeInitErrorMessage': 'There was a problem creating this Contact. Please refresh the page and try again.',
  'nav.objectBuilderSidebar.contact.successLinkText': 'View Contact',
  'nav.objectBuilderSidebar.contact.successMessage': 'A new Contact has been created',
  'nav.objectBuilderSidebar.deal.iframeInitErrorMessage': 'There was a problem creating this Deal. Please refresh the page and try again.',
  'nav.objectBuilderSidebar.deal.successLinkText': 'View Deal',
  'nav.objectBuilderSidebar.deal.successMessage': 'A new Deal has been created',
  'nav.objectBuilderSidebar.ticket.iframeInitErrorMessage': 'There was a problem creating this Ticket. Please refresh the page and try again.',
  'nav.objectBuilderSidebar.ticket.successLinkText': 'View Ticket',
  'nav.objectBuilderSidebar.ticket.successMessage': 'A new Ticket has been created',
  'nav.onboarding.buttons.finish': 'Finish',
  'nav.onboarding.buttons.next': 'Next',
  'nav.onboarding.buttons.previous': 'Back',
  'nav.onboarding.collapse.body': 'Expand or collapse the sidebar to make it the right size for you.',
  'nav.onboarding.collapse.header': 'Control your screen space',
  'nav.onboarding.modal.body': 'Save time and effort with our new sidebar and a more powerful search.',
  'nav.onboarding.modal.button': 'Take a quick tour',
  'nav.onboarding.modal.gif': 'Animated image of the old navigation experience transforming into the new one.',
  'nav.onboarding.modal.header': 'A faster navigation is here',
  'nav.onboarding.modal.link': 'Try it out now',
  'nav.onboarding.objCreate.body': 'Now, you can create {{object}}s and more right from the toolbar. No need to leave what you’re doing.',
  'nav.onboarding.objCreate.button.text': 'Got it',
  'nav.onboarding.objCreate.header': 'Create {{object}}s faster',
  'nav.onboarding.optout.body': 'For now, you can switch back to the original navigation through the account menu.',
  'nav.onboarding.optout.header': 'Switch back',
  'nav.onboarding.search.body': 'A more powerful search with keyboard shortcuts makes it easy to find what you need.',
  'nav.onboarding.search.header': 'Speed up with search',
  'nav.onboarding.steps': '{{ step }} of {{ numberOfSteps }}',
  'nav.onboarding.verticalNav.body': 'The menus are organized based on how you work, making it easier to find what you’re looking for.',
  'nav.onboarding.verticalNav.header': 'Find what you need easily',
  'nav.optIn.globalToolbarItem': 'Switch to the refreshed navigation',
  'nav.optInLink': 'Try the new navigation experience',
  'nav.optInTooltip.content': 'Your navigation will change on May 14th. Switch to the refreshed navigation now to help smooth the transition.',
  'nav.optInTooltip.header': 'Try the new navigation experience',
  'nav.optInTooltip.noThanksButton': 'Not today',
  'nav.optInTooltip.tryButton': 'Join now',
  'nav.optOutLink': 'Leave the new navigation experience',
  'nav.optOutTooltip.body': 'For now, you can switch back to the original navigation through the account menu.',
  'nav.optOutTooltip.button': 'Got it',
  'nav.optOutTooltip.header': 'Switch back',
  'nav.other.account.menu.label': 'View profile and more',
  'nav.other.calling.button.label': 'Calls',
  'nav.payments.defaultText': 'Collect payments with your CRM',
  'nav.payments.enrolledText': 'Receive your first payment',
  'nav.payments.hover.defaultText': 'Collect one-time and recurring payments from contacts, forms, quotes, and more.',
  'nav.payments.hover.enrolledText': 'Start collecting one-time and recurring payments from contacts, forms, quotes, and more.',
  'nav.payments.hover.preApprovedText': 'Enroll in HubSpot Payments to collect payments from invoices, payment links, quotes, subscriptions and more.',
  'nav.payments.preApprovedText': "You're pre-approved to collect payments",
  'nav.payments.title': 'Collect Payments',
  'nav.pinButton.collapseNav': 'Collapse navigation',
  'nav.pinButton.iconOnlyCollapseNav': 'Collapse the navigation',
  'nav.pinButton.iconOnlyKeepOpen': 'Expand the navigation',
  'nav.pinButton.keepOpen': 'Keep navigation open',
  'nav.search.activeSearch': 'Searching...,',
  'nav.search.activityType.CALL.company': 'Call on a company record',
  'nav.search.activityType.CALL.contact': 'Call on a contact record',
  'nav.search.activityType.CALL.deal': 'Call on a deal record',
  'nav.search.activityType.CALL.ticket': 'Call on a ticket record',
  'nav.search.activityType.EMAIL.company': 'Email on a company record',
  'nav.search.activityType.EMAIL.contact': 'Email on a contact record',
  'nav.search.activityType.EMAIL.deal': 'Email on a deal record',
  'nav.search.activityType.EMAIL.ticket': 'Email on a ticket record',
  'nav.search.activityType.MEETING.company': 'Meeting on a company record',
  'nav.search.activityType.MEETING.contact': 'Meeting on a contact record',
  'nav.search.activityType.MEETING.deal': 'Meeting on a deal record',
  'nav.search.activityType.MEETING.ticket': 'Meeting on a ticket record',
  'nav.search.activityType.NOTE.company': 'Note on a company record',
  'nav.search.activityType.NOTE.contact': 'Note on a contact record',
  'nav.search.activityType.NOTE.deal': 'Note on a deal record',
  'nav.search.activityType.NOTE.ticket': 'Note on a ticket record',
  'nav.search.associatedUrlText': 'Found on {{ searchResult }}',
  'nav.search.clearSearchLabel': 'Clear Search',
  'nav.search.close': 'close',
  'nav.search.composition.draft': 'Draft',
  'nav.search.createCompany': 'Create a new company',
  'nav.search.createCompanyWithQuery': 'Create a new company for \\"{{ searchTerm }}\\"',
  'nav.search.createContact': 'Create a new contact',
  'nav.search.createContactWithQuery': 'Create a new contact for \\"{{ searchTerm }}\\"',
  'nav.search.feedback.cancel': 'Cancel',
  'nav.search.feedback.commentsOrSuggestions': 'Comments or Suggestions?',
  'nav.search.feedback.helpful': 'They are helpful',
  'nav.search.feedback.howUseful': 'How useful are these results?',
  'nav.search.feedback.includeScreenshot': 'Include screenshot of my results with feedback.',
  'nav.search.feedback.notSubmitted': 'Your feedback was not submitted. Please try again.',
  'nav.search.feedback.notUseful': 'They are not useful',
  'nav.search.feedback.okayToContact': "It's okay to contact me about my feedback",
  'nav.search.feedback.optional': 'Optional',
  'nav.search.feedback.pleaseSelectOptions': 'Please select one of the above options.',
  'nav.search.feedback.resultRankingsNotGreat': 'Result rankings are not great',
  'nav.search.feedback.send': 'Send',
  'nav.search.feedback.somethingWrong': 'Something is wrong',
  'nav.search.feedback.submitted': 'Your feedback has been submitted.',
  'nav.search.feedback.whatWasExpectedResult': 'What was your expected result?',
  'nav.search.feedbackTextBoxPrompt': 'Can you tell us more about your experience with search?',
  'nav.search.fetchingRecentResults': 'Fetching your recent results…',
  'nav.search.filter': 'Filter',
  'nav.search.filterBy': 'Filter by',
  'nav.search.filterCount': 'Filters: {{ filterCount }}',
  'nav.search.headings.activity': 'Activity',
  'nav.search.headings.blog_post': 'Blog Posts',
  'nav.search.headings.campaign': 'Campaigns',
  'nav.search.headings.companies': 'Companies',
  'nav.search.headings.company': 'Companies',
  'nav.search.headings.contact': 'Contacts',
  'nav.search.headings.contacts': 'Contacts',
  'nav.search.headings.content_strategy_topic': 'Content Strategy Topics',
  'nav.search.headings.dashboard': 'Dashboards',
  'nav.search.headings.deal': 'Deals',
  'nav.search.headings.deals': 'Deals',
  'nav.search.headings.email': 'Emails',
  'nav.search.headings.knowledge_doc': 'Knowledge Base Doc',
  'nav.search.headings.landing_page': 'Landing Pages',
  'nav.search.headings.learning_center_lesson': 'HubSpot Academy Lessons',
  'nav.search.headings.learning_center_track': 'HubSpot Academy Courses',
  'nav.search.headings.list': 'Lists',
  'nav.search.headings.navigation': 'Navigation',
  'nav.search.headings.recently_modified': 'Recently Modified',
  'nav.search.headings.recently_searched': 'Recently Selected Results',
  'nav.search.headings.recently_selected_results': 'Recently selected results',
  'nav.search.headings.settings': 'Settings',
  'nav.search.headings.site_page': 'Site Pages',
  'nav.search.headings.task': 'Tasks',
  'nav.search.headings.ticket': 'Tickets',
  'nav.search.headings.transcript': 'Recorded Calls',
  'nav.search.headings.workflow': 'Workflows',
  'nav.search.howHappy': 'How happy are you with your search results?',
  'nav.search.intAlertBody': "It's moved to the main navigation. Look for the {{ marketPlaceIcon }} Marketplace icon.",
  'nav.search.intAlertTitle': 'Looking for Integrations?',
  'nav.search.lastActivityDate': 'Last activity date',
  'nav.search.lastModifiedDate': 'Last modified date',
  'nav.search.lastModifiedDateNew': 'Last modified date {{ date }}',
  'nav.search.mentions.ONE': '{{ count }} mention',
  'nav.search.mentions.OTHER': '{{ count }} mentions',
  'nav.search.mobile.searchInputPlaceholder': 'Start typing to find what you need',
  'nav.search.moreFilters': 'More filters',
  'nav.search.noFilteredResultCategories.ONE': 'No results found in this category.',
  'nav.search.noFilteredResultCategories.OTHER': 'No results found in these categories.',
  'nav.search.noFilteredResults': 'No results found. Try changing your selected categories or search terms.',
  'nav.search.noResults': 'No results found.',
  'nav.search.origin.CALL': 'Found in a call',
  'nav.search.origin.CONVERSATION_SESSION': 'Found in a conversation chat session',
  'nav.search.origin.EMAIL': 'Found in an email',
  'nav.search.origin.MEETING': 'Found in a meeting',
  'nav.search.origin.NOTE': 'Found in a note',
  'nav.search.origin.PROJECT_TASK': 'Found in a project task',
  'nav.search.origin.TASK': 'Found in a task',
  'nav.search.pleaseRefresh': 'Please refresh the page to try again.',
  'nav.search.searchHeader.back': 'Back to all results for \\"{{ query }}\\"',
  'nav.search.searchHeader.empty': 'Type something to start searching',
  'nav.search.searchHeader.query': 'Searching for \\"{{ query }}\\"',
  'nav.search.searchHeader.seeAll': 'See all results for \\"{{ query }}\\"',
  'nav.search.searchHeader.spellCheck': 'Did you mean <a class=\\"spellCheck\\">\\"{{ spellingCorrection }}\\"</a>?',
  'nav.search.searchInputPlaceholder': 'Search HubSpot',
  'nav.search.seeAllLink': 'See all',
  'nav.search.seeAllResults': 'See all',
  'nav.search.seeMore': 'See More',
  'nav.search.somethingHasGoneWrong': "Something's gone wrong. We were not able to get you to the transcript of the call.",
  'nav.search.somethingWentWrong': 'Something went wrong',
  'nav.search.submitFeedback': 'Submit',
  'nav.search.task.dueDate': 'Due date',
  'nav.search.task.dueDateNew': 'Due date: {{ formattedDueDate }}',
  'nav.search.task.type.CALL': 'Call',
  'nav.search.task.type.EMAIL': 'Email',
  'nav.search.task.type.TODO': 'Todo',
  'nav.search.tellUsMoreAboutFiltering': 'Can you tell us more about your experience with filtering search results?',
  'nav.search.thankyou': 'Thank you',
  'nav.search.thinkAboutFiltering': 'What do you think about filtering search results?',
  'nav.settings.items.payments.accounts': 'Payments account',
  'nav.shortcuts.add': 'Add to shortcuts',
  'nav.shortcuts.button.add.ariaLabel': 'Add {{ menuItem }} menu item to Shortcuts Menu',
  'nav.shortcuts.button.limitReached.ariaLabel': 'You can only have 5 shortcuts. To add {{ menuItem }} menu item, remove another one first',
  'nav.shortcuts.button.remove.ariaLabel': 'Remove {{ menuItem }} menu item from Shortcuts Menu',
  'nav.shortcuts.emptyList.first': 'Access your first shortcut for quick access',
  'nav.shortcuts.emptyList.firstString': 'Add your first shortcut for quick access.',
  'nav.shortcuts.emptyList.second': 'Select the star next to any item in the navigation to add it here.',
  'nav.shortcuts.icon.ariaLabel.default': 'Shortcuts icon',
  'nav.shortcuts.limitReached': 'You can only have 5 shortcuts. To add this, remove another one first.',
  'nav.shortcuts.primary': 'Shortcuts',
  'nav.shortcuts.remove': 'Remove from shortcuts',
  'nav.tools.academy': 'HubSpot Academy',
  'nav.tools.accounts': 'All accounts',
  'nav.tools.addons': 'Products & Add-ons',
  'nav.tools.allBrands': 'All Brands',
  'nav.tools.allBusinessUnits': 'All Business Units',
  'nav.tools.billing': 'Account & Billing',
  'nav.tools.businessUnitsPickerAriaLabel': 'Business unit: {{ businessName }}',
  'nav.tools.businessUnitsPickerAriaLabelV2': 'Brand: {{ businessName }}',
  'nav.tools.businessUnitsPickerDisclaimerText': 'Not all tools support business units filtering.',
  'nav.tools.businessUnitsPickerDisclaimerTextV2': 'Not all tools support brand filtering.',
  'nav.tools.businessUnitsPickerLink': 'Learn more',
  'nav.tools.businessUnitsPickerTitle': 'Business Unit',
  'nav.tools.businessUnitsPickerTitleV2': 'Brand',
  'nav.tools.cancel': 'Cancel',
  'nav.tools.chatspot': 'ChatSpot.ai',
  'nav.tools.createAccount': 'Create account',
  'nav.tools.devAccount': 'Account',
  'nav.tools.integrations': 'Integrations',
  'nav.tools.manageBusinessUnits': 'Manage business units',
  'nav.tools.manageBusinessUnitsV2': 'Manage brands',
  'nav.tools.marketplaces': 'Marketplaces',
  'nav.tools.portalPickerAriaLabel': '{{ accountName }} , HubSpot account ID: {{ portalId }}',
  'nav.tools.pricingAndFeatures': 'Pricing & Features',
  'nav.tools.privacy': 'Privacy policy',
  'nav.tools.productUpdates': 'Product Updates',
  'nav.tools.profileAndPreferences': 'Profile & Preferences',
  'nav.tools.projects': 'Projects',
  'nav.tools.signOut': 'Sign out',
  'nav.tools.trainingAndServices': 'Training & Services',
  'nav.tooltips.trialPicker': 'Free Trials',
  'nav.tooltips.upgrade': 'Upgrade',
  'nav.ui.components.loading.ariaLabel': 'Loading',
  'notifications.notificationTypes.archived': 'Archived',
  'notifications.prePermission.bodyTextBottom': 'To turn them on, click "allow" on the next screen.',
  'notifications.prePermission.bodyTextTop': 'Browser notifications allow you to get your notifications when you’re not active in HubSpot.',
  'notifications.prePermission.continueButton': 'Continue',
  'notifications.prePermission.header': 'Get HubSpot browser notifications',
  'notifications.prePermission.maybeLaterLink': 'Maybe later',
  'notifications.realTime.closeNotificationIcon': 'close notification icon',
  'notifications.realTime.moreOptionsEllipsis': 'More options',
  'notifications.realTime.tease.dontShowAgain': 'Don’t show me these again',
  'notifications.realTime.tease.example': 'example',
  'notifications.realTime.tease.goToPreferences': 'Go to notification preferences',
  'notifications.realTime.tease.turnOffSound': 'Turn off sound',
  'notifications.sidebar.actions': 'Actions',
  'notifications.sidebar.allArchived.description': 'They’re safely tucked away in your archive. Access them at any time by filtering.',
  'notifications.sidebar.allArchived.title': 'Hooray! All notifications archived.',
  'notifications.sidebar.archive': 'Archive',
  'notifications.sidebar.archiveAll': 'Archive all',
  'notifications.sidebar.cancel': 'Cancel',
  'notifications.sidebar.createdAt.aDayAgo': 'a day ago',
  'notifications.sidebar.createdAt.aFewSecondsAgo': 'a few seconds ago',
  'notifications.sidebar.createdAt.hourAgo': 'an hour ago',
  'notifications.sidebar.createdAt.hoursAgo': '{{ hoursCount }} hours ago',
  'notifications.sidebar.createdAt.minuteAgo': 'a minute ago',
  'notifications.sidebar.createdAt.minutesAgo': '{{ minutesCount }} minutes ago',
  'notifications.sidebar.CTA.call': 'Call',
  'notifications.sidebar.CTA.email': 'Email',
  'notifications.sidebar.CTA.seeLess': 'See less',
  'notifications.sidebar.CTA.seeMore': 'See more',
  'notifications.sidebar.dateDivider.April': 'April',
  'notifications.sidebar.dateDivider.August': 'August',
  'notifications.sidebar.dateDivider.December': 'December',
  'notifications.sidebar.dateDivider.February': 'February',
  'notifications.sidebar.dateDivider.January': 'January',
  'notifications.sidebar.dateDivider.July': 'July',
  'notifications.sidebar.dateDivider.June': 'June',
  'notifications.sidebar.dateDivider.March': 'March',
  'notifications.sidebar.dateDivider.May': 'May',
  'notifications.sidebar.dateDivider.November': 'November',
  'notifications.sidebar.dateDivider.October': 'October',
  'notifications.sidebar.dateDivider.September': 'September',
  'notifications.sidebar.dateDivider.thisMonth': 'This month',
  'notifications.sidebar.dateDivider.today': 'Today',
  'notifications.sidebar.dateDivider.yesterday': 'Yesterday',
  'notifications.sidebar.done': 'Done',
  'notifications.sidebar.emptyArchived.title': 'You don’t have any archived notifications',
  'notifications.sidebar.emptyFiltering.title': 'You don’t have any notifications from the filters you have chosen.',
  'notifications.sidebar.emptyState.description': 'But as soon as something happens, you’ll find it right here.',
  'notifications.sidebar.emptyState.title': 'You don’t have any notifications',
  'notifications.sidebar.error.description': 'We couldn’t load your notifications. Please try again.',
  'notifications.sidebar.error.refresh': 'Refresh',
  'notifications.sidebar.error.title': 'Something went wrong',
  'notifications.sidebar.filter': 'Filter',
  'notifications.sidebar.filterBy': 'Filter By',
  'notifications.sidebar.markAllAsRead': 'Mark all as read',
  'notifications.sidebar.markAsRead': 'Mark as read',
  'notifications.sidebar.notificationCard.checkboxAriaLabel': 'Select Notification',
  'notifications.sidebar.selectAll': 'Select all',
  'notifications.sidebar.selectAllSection.allNotificationsSelected': 'All your notifications are selected.',
  'notifications.sidebar.selectAllSection.clearSelection': 'Clear selection',
  'notifications.sidebar.selectAllSection.isSelectEveryNotificationSelected': 'Select every notification',
  'notifications.sidebar.selectAllSection.notificationsSelected': '{{ notificationCount }} notifications selected in this view.',
  'notifications.sidebar.selectAllSection.singleNotificationSelected': '1 notifications selected in this view.',
  'notifications.sidebar.selectedHeader.allNotificationsSelected': 'All selected',
  'notifications.sidebar.selectedHeader.notificationsSelected': '{{ notificationCount }} selected',
  'notifications.sidebar.unarchive': 'Unarchive',
  'notifications.sidebar.unarchiveAll': 'Unarchive all',
  'notifications.sidebar.undoArchiveTextPlural': '{{ notificationsCount }} notifications archived',
  'notifications.sidebar.undoArchiveTextSingular': '1 notification archived',
  'notifications.sidebar.undoButton': 'undo',
  'notifications.sidebar.undoUnarchiveTextPlural': '{{ notificationsCount }} notifications unarchived',
  LANG_FROM_NAVCONFIG: 'en'
};